import { apiPost, authenticate } from "@redriver/cinnamon";

const NAMESPACE = "SYSTEM/AZURE_SSO_SIGN_IN";
export const REQUEST_SSO_LOGIN = `${NAMESPACE}/REQUEST`;

export const requestSsoLogin = ({ code, codeVerifier }) => async (dispatch) => {
  if (!code || !codeVerifier) {
    return {
      success: false,
      error: {
        message:
          "Missing sign-in parameters. Please return to the sign-in page and try again.",
      },
    };
  }

  const loginAction = apiPost(
    REQUEST_SSO_LOGIN,
    "auth/sso/azure-ad",
    { code, codeVerifier },
    { auth: false, preventErrorNotification: true }
  );
  const result = await dispatch(loginAction);

  const { success, response } = result;
  if (success) {
    const { accessToken, refreshToken } = response.tokens;
    dispatch(authenticate(accessToken, refreshToken));
  }

  return result;
};
